import { useEffect, useState } from 'react';
import { publicAssetUrl, WEIRDPHYSICS_PREVIEW_FONTS } from './presets';

let fontLoadPromise: Promise<void> | null = null;
let fontsRegistered = false;

const loadCarouselFonts = async (): Promise<void> => {
  if (typeof document === 'undefined' || typeof FontFace === 'undefined' || !document.fonts) {
    fontsRegistered = true;
    return;
  }

  if (fontsRegistered) return;

  const headline = new FontFace(
    WEIRDPHYSICS_PREVIEW_FONTS.headline,
    `url("${publicAssetUrl('/remotion/fonts/Impact.ttf')}")`
  );
  const body = new FontFace(
    WEIRDPHYSICS_PREVIEW_FONTS.body,
    `url("${publicAssetUrl('/remotion/fonts/Inter-italic.otf')}")`
  );

  const [loadedHeadline, loadedBody] = await Promise.all([headline.load(), body.load()]);
  document.fonts.add(loadedHeadline);
  document.fonts.add(loadedBody);
  await document.fonts.ready;
  fontsRegistered = true;
};

export const useCarouselPreviewFonts = (): boolean => {
  const [loaded, setLoaded] = useState(fontsRegistered);

  useEffect(() => {
    let cancelled = false;
    if (!fontLoadPromise) {
      fontLoadPromise = loadCarouselFonts();
    }
    fontLoadPromise
      .then(() => {
        if (!cancelled) setLoaded(true);
      })
      .catch(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return loaded;
};
